// src/slices/subscriptionSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { createCustomer, getPlan, handleFatchPayment, handlePayment } from './subscriptionThunk';
// import { createCustomer, handlePayment, handleFatchPayment } from '../thunks/subscriptionThunks';

const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState: {
        // customer: null,
        // paymentStatus: null,
        // loading: false,
        // error: null,
        createCustomerloading: null,
        createCustomerError: null,
        createCustomerFullfill: null,

        handlePaymentloading: null,
        handlePaymentError: null,
        handlePaymentFullfill: null,

        handleFatchPaymentLoading: null,
        handleFatchPaymentError: null,
        handleFatchPaymentFullfill: null,

        getPlanLoading: null,
        getPlanError: null,
        getPlanFullfill: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Customer
            .addCase(createCustomer.pending, (state) => {
                state.createCustomerloading = true;
                state.createCustomerError = null;
            })
            .addCase(createCustomer.fulfilled, (state, action) => {
                state.createCustomerloading = false;
                state.createCustomerFullfill = action.payload;
            })
            .addCase(createCustomer.rejected, (state, action) => {
                state.createCustomerloading = false;
                state.createCustomerError = action.payload;
            })

            // Handle Payment
            .addCase(handlePayment.pending, (state) => {
                state.handlePaymentloading = true;
                state.handlePaymentError = null;
            })
            .addCase(handlePayment.fulfilled, (state, action) => {
                state.handlePaymentloading = false;
                state.handlePaymentFullfill = action.payload;
            })
            .addCase(handlePayment.rejected, (state, action) => {
                state.handlePaymentloading = false;
                state.handlePaymentError = action.payload;
            })

            // Fetch Payment Status
            .addCase(handleFatchPayment.pending, (state) => {
                state.handleFatchPaymentLoading = true;
                state.handleFatchPaymentError = null;
            })
            .addCase(handleFatchPayment.fulfilled, (state, action) => {
                state.handleFatchPaymentLoading = false;
                state.handleFatchPaymentFullfill = action.payload;
            })
            .addCase(handleFatchPayment.rejected, (state, action) => {
                state.handleFatchPaymentLoading = false;
                state.handleFatchPaymentError = action.payload;
            })

            // Get Plan
            .addCase(getPlan.pending, (state) => {
                state.getPlanLoading = true;
            })
            .addCase(getPlan.fulfilled, (state, action) => {
                state.getPlanLoading = false;
                state.getPlanFullfill = action.payload;
            })
            .addCase(getPlan.rejected, (state, action) => {
                state.getPlanLoading = false;
                state.getPlanError = action.payload;
            })
    },
});

export default subscriptionSlice.reducer;
